<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-home"></i> 分支机构管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
		<div class="handle-box">
			<el-button
			    type="primary"
			    icon="el-icon-circle-plus-outline"
			    class="handle-add"
			    @click="handleadd('addform')"
			>添加分支机构</el-button>
		</div>
        <div class="container">
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
            >
                <el-table-column prop="loginName" label="管理员账号"></el-table-column>
                <el-table-column prop="responsibleAreaStr" label="管理区域"></el-table-column>
				<el-table-column prop="createTimeStr" label="创建时间"></el-table-column>
                <el-table-column prop="statusStr" label="状态" align="center"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
						<el-button
						    type="text"
						    icon="el-icon-view"
						    @click="handlsee(scope.row)"
						>查看</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.row)"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
		<!-- 添加机构分支 -->
		<el-dialog class="branch-dialog" title="添加分支机构" :visible.sync="addVisible" width="600px">
		    <el-form ref="addform" :model="addform" :rules="addrules">
				<p class="branch-dialog-title">
					权限信息
				</p>
		        <el-form-item label="分支机构名称" prop="name">
		            <el-input v-model="addform.name"></el-input>
		        </el-form-item>
		        <el-form-item label="负责人" prop="liaisonerName">
		            <el-input v-model="addform.liaisonerName"></el-input>
		        </el-form-item>
				<!-- 负责区域 -->
				<p class="branch-area">
					<span>负责区域</span>
					<i @click="cityAdd()" class="el-icon-circle-plus-outline" style="color: #409EFF;"></i>
				</p>
				<el-form-item
					class="branch-areaitem"
					v-for="(domain, index) in addform.domains"
					:key="index"
					:prop="'domains.' + index"
					:rules="{
					  required: true, message: '区域不能为空', trigger: 'change'
					}"
				  >
					<el-cascader :options="cityList" :props="optionProps" v-model="addform.domains[index]"></el-cascader>
					<b  v-if="index>0" class="el-icon-delete" style="color: #409EFF;" @click="citydelete(domain)"></b>
				  </el-form-item>
				
				
				 <el-form-item label="选择权限">
				      <el-checkbox v-model="addform.isHaveLicense">机械牌照办理</el-checkbox>
				      <el-checkbox v-model="addform.isHaveOperationCertificate">机械操作证件办理</el-checkbox>
				  </el-form-item>
				
				<p class="branch-dialog-title">
					账号信息
				</p>
				<el-form-item label="用户名" prop='loginName'>
				    <el-input v-model="addform.loginName"></el-input>
				</el-form-item>
				
				<el-form-item label="密码" prop="passWord" class="branch-password">
				    <el-input type="password" v-model="addform.passWord" autocomplete="off"></el-input>
				  </el-form-item>
				  <el-form-item label="确认密码" prop="checkPass" class="branch-password">
				    <el-input type="password" v-model="addform.checkPass" autocomplete="off"></el-input>
				  </el-form-item>
			
				<el-form-item label="邮箱"
					prop="emailAddress"
				>
				    <el-input v-model="addform.emailAddress"></el-input>
				</el-form-item>
				<el-form-item label="状态">
				    <el-radio-group v-model="addform.status">
				        <el-radio label="1">是</el-radio>
				        <el-radio label="2">否</el-radio>
				    </el-radio-group>
				</el-form-item>
		    </el-form>
			
		    <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="saveAdd('addform')">确 定</el-button>
		        <el-button @click="addVisible = false">取 消</el-button>
		    </span>
		</el-dialog>
		
		<!-- 查看弹框 -->
		<el-dialog class="branch-dialog" title="查看分支机构" :visible.sync="seeVisible" width="600px">
			<p class="branch-dialog-title">
				权限信息
			</p>
			<div class="see-list">
				<p>分支机构名称: <span>{{seebrachlist.name}}</span></p>
				<p>负责人: <span>{{seebrachlist.liaisonerName}}</span></p>
				<p>权限区域: <span>{{seebrachlist.responsibleAreaStr}}</span></p>
			</div>
			<p class="branch-dialog-title">
				账号信息
			</p>
			<div class="see-list">
				<p>用户名: <span>{{seebrachlist.loginName}}</span></p>
				<p>邮箱: <span>{{seebrachlist.emailAddress}}</span></p>
				<p>状态: <span>{{seebrachlist.statusStr}}</span></p>
			</div>
		    
		</el-dialog>
		
		
        <!-- 编辑弹出框 -->
        <el-dialog class="branch-dialog" title="编辑分支机构" :visible.sync="editVisible" width="600px">
            <el-form ref="editform" :model="editform" :rules="editrules">
            	<p class="branch-dialog-title">
            		权限信息
            	</p>
                <el-form-item label="分支机构名称" prop="name">
                    <el-input v-model="editform.name"></el-input>
                </el-form-item>
                <el-form-item label="负责人" prop="liaisonerName">
                    <el-input v-model="editform.liaisonerName"></el-input>
                </el-form-item>
				<p class="branch-area">
					<span>负责区域</span>
					<i @click="cityAddedit()" class="el-icon-circle-plus-outline" style="color: #409EFF;"></i>
				</p>
            	<el-form-item
            		class="branch-areaitem"
            		v-for="(domain, index) in editform.domains"
            		:key="index"
            		:prop="'domains.' + index"
            		:rules="{
            		  required: true, message: '区域不能为空', trigger: 'change'
            		}"
            	  >
            		<el-cascader :options="cityList" :props="optionProps" v-model="editform.domains[index]"></el-cascader>
            		<b  v-if="index>0" class="el-icon-delete" style="color: #409EFF;" @click="citydeleteedit(domain)"></b>
            	  </el-form-item>
            	<el-form-item label="选择权限">
            	     <el-checkbox v-model="editform.isHaveLicense">机械牌照办理</el-checkbox>
            	     <el-checkbox v-model="editform.isHaveOperationCertificate">机械操作证件办理</el-checkbox>
            	 </el-form-item>
            	<p class="branch-dialog-title">
            		账号信息
            	</p>
            	<el-form-item label="用户名" prop="loginName">
            	    <el-input v-model="editform.loginName"></el-input>
            	</el-form-item>
            	<el-form-item label="密码" prop="passWord">
            	    <el-input v-model="editform.passWord"></el-input>
            	</el-form-item>
            	<el-form-item label="确认密码" prop="checkPass">
            	    <el-input v-model="editform.checkPass"></el-input>
            	</el-form-item>
            	<el-form-item label="邮箱" prop="emailAddress">
            	    <el-input v-model="editform.emailAddress"></el-input>
            	</el-form-item>
            	<el-form-item label="状态" prop="status">
            	    <el-radio-group v-model="editform.status">
            	        <el-radio label="1">是</el-radio>
            	        <el-radio label="2">否</el-radio>
            	    </el-radio-group>
            	</el-form-item>
            </el-form>
            
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit('editform')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>




<script>
import {saveBranchOrganization,listBranchOrganizations,getBranchOrganization,deleteBranchOrganization,updateBranchOrganization,listProvinceCitys } from '@/api/index';// 导入我们的api接口

export default {
    name: 'branchmgment',
    data() {
		var validatePass = (rule, value, callback) => {
			if (value === '') {
			  callback(new Error('请输入密码'));
			} else {
				
				const reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,20}$/;
				
				if(!reg.test(value)){
					callback(new Error('密码需要8-20位，需要包含字母、数字、符号。'));
				}
				
			  if (this.addform.checkPass !== '') {
				this.$refs.addform.validateField('checkPass');
			  }
			  callback();
			}
		};
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
			  callback(new Error('请再次输入密码'));
			} else if (value !== this.addform.passWord) {
			  callback(new Error('两次输入密码不一致!'));
			} else {
			  callback();
			}
		  };      //输入密码和确认密码校验
		  var validatePass3 = (rule, value, callback) => {
			if (value !== this.editform.passWord) {
		  	  callback(new Error('两次输入密码不一致!'));
		  	} else {
		  	  callback();
		  	}
		    };      //输入密码和确认密码校验
			var validatePass4 = (rule, value, callback) => {
				if (value) {
					const reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,20}$/;
					if(!reg.test(value)){
						callback(new Error('密码需要8-20位，需要包含字母、数字、符号。'));
					}
				  if (this.editform.checkPass !== '') {
					this.$refs.editform.validateField('checkPass');
				  }
				  callback();
				}else {
					callback();
				}
			}	
        return {
			cityList:[],//省市数据
			optionProps: {
					value: 'id',
					label: 'name'
			},   //省市联动重命名指向
            query: {
                pageIndex: 1,
                pageSize: 10
            },   //分页
			pageTotal: 0,  //数据总条数
            tableData: [],  //列表数据
			addform:{
				name:'',
			    liaisonerName:'',
				domains: [[]],  //负责区域中间量
				responsibleArea:[],  //负责区域提交量
				isHaveLicense:false,
			    isHaveOperationCertificate:false,
				loginName:'',//用户名
				passWord:'',
				checkPass:'',
				emailAddress:'',
				status:'1'
			},    //添加机构分支表单
			seebrachlist:{},   //查看数据
			addrules: {
				  name: [
					{ required: true, message: '请输入分支机构名称', trigger: 'blur' }
				  ],
				  liaisonerName: [
					{ required: true, message: '请输入负责人', trigger: 'blur' }
				  ],
				  branchaddress: [
					{ type: 'date', required: true, message: '请选择日期', trigger: 'change' }
				  ],
				  loginName:[
					  { required: true, message: '请输入用户名', trigger: 'blur' }
				  ],
				  emailAddress:[
					   { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
				  ],
				  passWord: [
					  { validator: validatePass, trigger: 'blur' }
					],
					checkPass: [
					  { validator: validatePass2, trigger: 'blur' }
					],
				  
				},  //添加表单验证
				// editform:{},
				domainsedit: [],
			editform:{
				domains: [],  //负责区域中间量
			},   //编辑表单
			editrules: {
				  name: [
					{ required: true, message: '请输入分支机构名称', trigger: 'blur' }
				  ],
				  liaisonerName: [
					{ required: true, message: '请输入负责人', trigger: 'blur' }
				  ],
				  branchaddress: [
					{ type: 'date', required: true, message: '请选择日期', trigger: 'change' }
				  ],
				  loginName:[
					  { required: true, message: '请输入用户名', trigger: 'blur' }
				  ],
				  emailAddress:[
					   { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
				  ],
					passWord: [
					  { validator: validatePass4, trigger: 'blur' }
					],
					checkPass: [
					  { validator: validatePass3, trigger: 'blur' }
					],
				  
				},  //添加表单验证
			
			addVisible:false,  //添加分支机构
			seeVisible:false, //查看分支机构
            editVisible: false, //编辑分支机构
			
            
			
        };
    },
    created() {
		var that = this;
		// 列表数据
		this.getlistBranchOrganizations();
		listProvinceCitys({
		}).then(res => {
		    // 获取数据成功后的其他操作
			that.cityList = res.data;
		})
		
    },
    methods: {
		// 获取列表数据
		getlistBranchOrganizations(){
			listBranchOrganizations({
				current: this.query.pageIndex,                    
				size: this.query.pageSize              
			}).then(res => {
				// 获取数据成功后的其他操作
				if(res.code == 0){
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				}
				
			});
		},
		//点击添加按钮事件
		handleadd(formName){
			this.addVisible = true;
			
			this.addform.domains = [[]];
			//重置表单数据
			this.$nextTick(()=>{
			  this.$refs.[formName].resetFields();
			})
		},
		// 添加保存
		saveAdd(formName) {
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				  // 字段处理
				  // 负责区域字段格式处理
				  var responsibleArea = [];
				  console.log(this.addform.domains)
				  for(var i in this.addform.domains){
				  	if(this.addform.domains[i]){
				  		responsibleArea.push(this.addform.domains[i].join(','));
				  	}
				  }
				  this.addform.responsibleArea = JSON.stringify(responsibleArea);
				  console.log(this.addform.responsibleArea)
				  // 是否可以办理牌照:1、不可以 2、可以
				  if(this.addform.isHaveLicense){
				  	this.addform.isHaveLicense = 2;
				  }else{
				  	this.addform.isHaveLicense = 1;
				  }
				  // 是否可以办理操作证书:1、不可以 2、可以
				  if(this.addform.isHaveOperationCertificate){
				  	this.addform.isHaveOperationCertificate = 2;
				  }else{
				  	this.addform.isHaveOperationCertificate = 1;
				  }
				  
				  saveBranchOrganization(this.addform).then(res => {
					  this.getlistBranchOrganizations();
					  if(res.code == 0){
						  // 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							this.addVisible = false;
					  }else if(res.code == 1){
						  this.$message({
						    message: res.message,
						    type: 'warning'
						  });
					  }else{
						  this.$message({
						    message: '报错啦!',
						    type: 'warning'
						  });
					  }
					   
				  });
			  } else {
				return false;
			  }
			});
		  },
		
		// 省市联动增加
		cityAdd() {
			console.log(this.addform.domains)
		  this.addform.domains.push([]);
		},
		//省市联动删除
       citydelete(item) {
		   console.log(item)
		   var that = this;
		   var index = this.addform.domains.indexOf(item)
		   if (index !== -1) {
			 this.addform.domains.splice(index, 1)
		   }
		 },
	   // 查看操作
	   handlsee(row){
		  this.seeVisible = true; 
		  getBranchOrganization({
			 "accountId": row.accountId,
			 "organizationId": row.organizationId,
			 "personId": row.personId              
		  }).then(res => {
			  // 获取数据成功后的其他操作
			  this.seebrachlist = res.data;        
		  });
	   },
        // 删除操作
        handleDelete(row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
				deleteBranchOrganization({
					 "accountId": row.accountId,
					 "organizationId": row.organizationId,
					 "personId": row.personId              
				}).then(res => {
					this.getlistBranchOrganizations();
					if(res.code == 0){
					  // 获取数据成功后的其他操作
						this.$message({
						  message: res.message,
						  type: 'success'
						});
					}else if(res.code == 1){
						  this.$message({
							message: res.message,
							type: 'warning'
						  });
					}else{
						  this.$message({
							message: '报错啦!',
							type: 'warning'
						  });
					}
					
				});
			}).catch(() => {});
        },
        // 编辑操作updateBranchOrganization
        handleEdit(row) {
			this.domainsedit = [];
			this.editVisible = true;
			getBranchOrganization({
						 "accountId": row.accountId,
						 "organizationId": row.organizationId,
						 "personId": row.personId              
			}).then(res => {
						  // 获取数据成功后的其他操作
						  this.editform = res.data;  
						  this.editform.status = res.data.status + '';
						  // 是否可以办理牌照:1、不可以 2、可以
						  if(this.editform.isHaveLicense == 2){
						  	this.editform.isHaveLicense = true;
						  }else{
						  	this.editform.isHaveLicense = false;
						  }
						  // 是否可以办理操作证书:1、不可以 2、可以
						  if(this.editform.isHaveOperationCertificate == 2){
						  	this.editform.isHaveOperationCertificate = true;
						  }else{
						  	this.editform.isHaveOperationCertificate = false;
						  }
						  
						  var responsibleAreazjl = JSON.parse(this.editform.responsibleArea);
						  for(var i in responsibleAreazjl){
								  var domains1 = [];
								  var Areazjl1 = responsibleAreazjl[i];
								  var Areazjl2 = Areazjl1.split(',')
								  domains1 = [parseInt(Areazjl2[0]),parseInt(Areazjl2[1])];
								  this.domainsedit.push(domains1);
						  }
						  this.$set(this.editform, 'domains', this.domainsedit)
						
						  
						  
						
			});
			
			
			
        },
		
		// 省市联动增加
		cityAddedit() {
			// debugger
			var that = this;
			that.editform.domains.push([]);
		},
				//省市联动删除
		citydeleteedit(item) {
			
			console.log(item)
			var that =  this;
				   var index = that.editform.domains.indexOf(item)
				   if (index !== -1) {
					 that.editform.domains.splice(index, 1)
				   }
		},
		
        // 保存编辑
        saveEdit(formName) {
			console.log(formName);
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				  // 字段处理
				  // 负责区域字段格式处理
				  var responsibleArea = [];
				  console.log(this.editform.domains)
				  for(var i in this.editform.domains){
				  	if(this.editform.domains[i]){
				  		responsibleArea.push(this.editform.domains[i].join(','));
				  	}
				  }
				  this.editform.responsibleArea = JSON.stringify(responsibleArea);
				  console.log(this.editform.responsibleArea)
				  // 是否可以办理牌照:1、不可以 2、可以
				  if(this.editform.isHaveLicense){
				  	this.editform.isHaveLicense = 2;
				  }else{
				  	this.editform.isHaveLicense = 1;
				  }
				  // 是否可以办理操作证书:1、不可以 2、可以
				  if(this.editform.isHaveOperationCertificate){
				  	this.editform.isHaveOperationCertificate = 2;
				  }else{
				  	this.editform.isHaveOperationCertificate = 1;
				  }
				  
				  updateBranchOrganization(this.editform).then(res => {
					  this.getlistBranchOrganizations();
					  if(res.code == 0){
						  // 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							this.editVisible = false;
					  }else if(res.code == 1){
						  this.$message({
						    message: res.message,
						    type: 'warning'
						  });
					  }else{
						  this.$message({
						    message: '报错啦!',
						    type: 'warning'
						  });
					  }
					   
				  });
			  } else {
				return false;
			  }
			});
			
			
			
			
            // this.editVisible = false;
            // this.$message.success(`修改第 ${this.idx + 1} 行成功`);
            // this.$set(this.tableData, this.idx, this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getlistBranchOrganizations();
        }
    }
};
</script>

<style scoped>
.handle-box {
	height: 32px;
	line-height: 32px;
    margin-bottom: 20px;
}
.handle-add{
	float: right;
}
.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

/* 弹框样式 */
.branch-dialog-title{
	border-left: 4px solid #409EFF;
	font-size: 16px;
	text-indent: 10px;
	margin-bottom: 20px;
}

.see-list p{
	/* line-height: 32px; */
	margin-bottom: 20px;
	letter-spacing: 1px;
	font-size: 14px;
	text-indent: 15px;
}



</style>
<style>
.branch-dialog	.el-dialog__header{
	background:#409EFF;
	padding: 10px 20px;
}
.branch-dialog	.el-dialog__header	.el-dialog__title{
	color: #fff;
}
.branch-dialog	.el-dialog__header .el-dialog__headerbtn{
	background:#409EFF;
	top: 12px;
}
.branch-dialog	.el-dialog__header .el-dialog__headerbtn .el-dialog__close{
	color: #fff;
	font-size: 20px;
}
.branch-dialog .el-dialog__body{
	height:50vh;
	overflow-y: scroll;
	padding: 20px 20px 30px;
}
.branch-dialog .el-form-item__label{
	/* text-align: left; */
	width: 130px;
}
.branch-dialog .el-form-item__content{
	margin-left: 130px;
}

.branch-area{
	position: relative;
	height:32px;
	line-height: 32px;
	margin-bottom: 4px;
}
.branch-area span{
	display: block;
	width:118px;
	text-align: right;
}
.branch-area span::before{
	content: '*';
	color: #F56C6C;
	margin-right: 4px;
}
.branch-area i{
	position: absolute;
	top: 7px;
	right: 0;
	font-size: 20px;
	cursor: pointer;
}
.branch-areaitem{
	position: relative;
}
.branch-areaitem .el-cascader{
	width: 90%;
}
.branch-areaitem b{
	position: absolute;
	top: 7px;
	right: 0;
	font-size: 20px;
	cursor: pointer;
}
.branch-password .el-form-item__label::before{
	content: '*';
	color: #F56C6C;
	margin-right: 4px;
}
</style>
